import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "../system"
import { DocumentSnapshotLike } from "../../firestore"
import { SubscriptionPlatform } from "./subscription"
import { ItemId, SubscriptionItemGrantMasterId } from "../../id"

export const SubscriptionItemGrantMeta = z.object({
  master_id: z.string().transform(SubscriptionItemGrantMasterId).describe("SubscriptionItemGrantMasterのID"),
  subscription_id: z.string().describe("サブスクリプションID"),
  subscription_kind: z.enum(["premium", "premium-plus"]).describe("配布時のサブスクリプション種別"),
  platform: SubscriptionPlatform.describe("プラットフォーム"),
  item_id: z.string().transform(ItemId).describe("配布アイテムID"),
  personal_notification_id: z.string().nullable().describe("PersonalNotificationのID"),
})

export type SubscriptionItemGrantMeta = z.infer<typeof SubscriptionItemGrantMeta>

export const SubscriptionItemGrantDocumentBody = SubscriptionItemGrantMeta.extend({
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type SubscriptionItemGrantDocumentBody = z.infer<typeof SubscriptionItemGrantDocumentBody>

export type SubscriptionItemGrantDocument = SubscriptionItemGrantDocumentBody & {
  id: string
}

export class SubscriptionItemGrantDocuments {
  static toDocumentData(doc: SubscriptionItemGrantDocumentBody): object {
    return {
      ...doc,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): SubscriptionItemGrantDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: doc.id,
      master_id: SubscriptionItemGrantMasterId(data["master_id"]),
      subscription_id: data["subscription_id"],
      subscription_kind: data["subscription_kind"],
      platform: data["platform"],
      item_id: ItemId(data["item_id"]),
      personal_notification_id: data["personal_notification_id"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
